export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    MODAL_BOX: "CybotCookiebotDialog",
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};
export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    MODAL_BOX: "CybotCookiebotDialog",
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};
